import '../../Tenants/Tenants/tenants.scss'

import React, { useMemo, useState } from 'react'
import { Button, Result, Table, notification } from 'antd'
import classnames from 'classnames'
import { Column, Row } from 'react-display-flex'
import useSWR from 'swr'

import { onboardingFetcher } from '../../../api'
import { buildTableFilterKeys } from '../../../components/tables/build-table-filter-keys'
import { messages } from '../messages'
import { ProposedTenant } from '../models'
import { buildTenantsTableColumns } from './proposed-tenants-table-columns'
import { UpdateProposedTenantDrawer } from './UpdateProposedTenant/UpdateProposedTenantDrawer'
import { httpClient } from '../../../util/http-client'

const tenantsApproveUrl = '/proposed-tenants/approve/'
const selectedInitialTenants = []

export const ProposedTenants = () => {
  const [tenantId, setTenantId] = useState(null)
  const [selectedTenants, setSelectedTenants] = useState(selectedInitialTenants)
  const [isApprovingTenants, setIsApprovingTenants] = useState(false)

  const {
    data: tenants,
    mutate,
    error,
  } = useSWR<ProposedTenant[]>('/proposed-tenants/', onboardingFetcher, { suspense: true })

  const tableFilterMenuItems = useMemo(
    () => ({
      segmentCodes: buildTableFilterKeys(tenants, 'segmentCode'),
    }),
    [tenants],
  )

  const onApproveTenants = async () => {
    setIsApprovingTenants(true)
    try {
      await httpClient(tenantsApproveUrl, { onboardingService: true, method: 'PUT', data: { ids: selectedTenants } })
      notification.success({ message: messages.common.success, description: messages.proposedTenant.approve.success })
      mutate()
      setSelectedTenants(selectedInitialTenants)
    } catch (error) {
      notification.error({ message: messages.common.error, description: messages.proposedTenant.approve.error })
    } finally {
      setIsApprovingTenants(false)
    }
  }

  const onUpdate = (currentTenantId: number) => {
    setTenantId(currentTenantId)
  }

  const onClose = () => {
    setTenantId(null)
  }

  const onSuccess = () => {
    mutate()
    onClose()
  }

  const columns = buildTenantsTableColumns({
    onUpdate,
    tableFilterMenuItems,
  })

  if (error) {
    return <Result status="error" title={messages.proposedTenant.list.error} />
  }

  return (
    <Column className="tenants">
      <Row justifyContentEnd>
        <Button
          type="primary"
          onClick={onApproveTenants}
          loading={isApprovingTenants}
          disabled={selectedTenants.length === 0}
        >
          Approve selected customers
        </Button>
      </Row>
      <Table
        rowClassName={(tenant: ProposedTenant) => classnames({ active: tenant.id === tenantId })}
        columns={columns}
        dataSource={tenants}
        loading={!tenants}
        rowKey="id"
        pagination={false}
        size="small"
        rowSelection={{
          selectedRowKeys: selectedTenants,
          onChange: (selectedRows) => setSelectedTenants(selectedRows),
          getCheckboxProps: ({ acceptanceStatus }) => ({
            disabled: acceptanceStatus !== 'IN_PROGRESS',
          }),
        }}
      />
      <UpdateProposedTenantDrawer tenantId={tenantId} isVisible={!!tenantId} onClose={onClose} onSuccess={onSuccess} />
    </Column>
  )
}
